import { IBaseModel, BaseModel } from '../base.model';
import { IAddress } from '../address/address.model';

export interface ITeamMember extends IBaseModel {
  role?: number
  civility?: number
  lastname?: string
  firstname?: string
  //address?: string
  address_secondary?: string
  code_postal?: string
  city?: string
  country?: string
  email?: string
  fake_email?:boolean
  landline?: string
  cellphone?: string
  num_siret?: number
  code_ape?: string
  num_tva?: string
  specialization?: number[]
  blocks?: any[]
  apartments?: any[]
  address?: IAddress
  trigram?:string,
  parent_entity?:number
  charPb1?:number[]
  charPb2?:number[]
  char_pb?:{level_1:any[],level_2:any[]}
}

export class TeamMemberDto extends BaseModel implements ITeamMember {
  /**
   *
   */
  role?: number
  civility?: number
  lastname?: string
  firstname?: string
  //address?: string
  address_secondary?: string
  code_postal?: string
  city?: string
  country?: string
  email?: string
  fake_email?:boolean
  password?:string
  landline?: string
  cellphone?: string
  num_siret?: number
  code_ape?: string
  num_tva?: string
  specialization?: number[]
  blocks?: any[]
  apartments?: any[]
  address?: IAddress
  trigram?:string
  parent_entity?:number
  charPb1?:number[]
  charPb2?:number[]
  char_pb?:{level_1:any[],level_2:any[]}

  constructor(opt: ITeamMember) {
    super(opt);
  }
}



// WEBPACK FOOTER //
// ./src/models/profile/member.model.ts